module.exports = __webpack_public_path__ + "static/media/ring.0dc92b4e.svg";